import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { firstValueFrom, Subject } from "rxjs";

/** Server DTO — matches UniformaxController.PendingPoCancelRequestDTO. */
export interface PendingPoCancelRequest {
  Id: number;
  ManufacturerId: number;
  ManufacturerName: string;
  PoHeaderId: number;
  PoDetailId: number;
  QueuedTs: string;
  QueuedByUserInit: string;
}

export interface FlushPoCancelRequestQueueResponse {
  EmailsSent: number;
}

/**
 * Client-side facade for the PoCancelRequestQueue endpoints on
 * UniformaxController. Facilitation flows call `refreshRequested$.next()` after
 * a successful fill so the tray reloads without polling.
 * Design doc: docs/in-flight-order-changes.md §4.5.1.
 */
@Injectable({ providedIn: "root" })
export class PoCancelRequestQueueService {
  readonly refreshRequested$ = new Subject<void>();

  constructor(private http: HttpClient) {}

  async getPending(): Promise<PendingPoCancelRequest[]> {
    const url = `${environment.apiRoot}breeze/uniformax/GetPendingPoCancelRequests`;
    return (await firstValueFrom(this.http.get<PendingPoCancelRequest[]>(url))) ?? [];
  }

  async flush(): Promise<FlushPoCancelRequestQueueResponse> {
    const url = `${environment.apiRoot}breeze/uniformax/FlushPoCancelRequestQueue`;
    return (
      (await firstValueFrom(this.http.post<FlushPoCancelRequestQueueResponse>(url, {}))) ?? {
        EmailsSent: 0,
      }
    );
  }
}
